export const MINIMUM_STANDARD_OF_LIVING = 14233;
export const MAXIMUM_TAX_FREE_CASH = 268275;
export const STATE_PENSION = 12547;
